import type { FileImageUsage } from '@vedalib/editor/lib/files'
import cn from 'classnames'
import { FileTypeEnum } from 'utils'

import { genElementValueField } from 'components/Editor/Toolbar/NodeForm/genElementValueField'
import Padding from 'components/Editor/Toolbar/Padding'
import { FieldColorPicker, FieldFile, FormField } from 'components/formKit'
import Button from 'components/uiKit/Button'
import Divider from 'components/uiKit/Divider'
import { useBrandColorOptions } from 'services/Branding/fieldConfigs/useFieldConfigs'
import { t } from 'services/Translation'
import { chainName } from 'utils/form'

import * as s from './CardForm.module.scss'
import type { CardFormValueType } from './cardTypes'

const FRONT_IMAGE = genElementValueField({
  as: FieldFile<FileImageUsage>,
  name: 'front.image',
  label: t('elements.card.form.sideA'),
  layout: 'vertical',
  props: {
    fileType: FileTypeEnum.IMAGE,
    nullable: true,
    preview: true,
    showSource: true,
    hasObjectFit: true,
    hasAccessibility: true,
  },
})

const FRONT_OVERLAY = genElementValueField({
  as: FieldColorPicker<string | null>,
  name: 'front.overlay',
  label: t('input.label.overlay'),
  defaultValue: null,
  useConfigs: [useBrandColorOptions],
  props: { labeled: true, resettable: true },
})

const BACK_IMAGE = genElementValueField({
  as: FieldFile<FileImageUsage>,
  name: 'back.image',
  label: t('elements.card.form.sideB'),
  layout: 'vertical',
  props: {
    fileType: FileTypeEnum.IMAGE,
    nullable: true,
    preview: true,
    showSource: true,
    hasObjectFit: true,
    hasAccessibility: true,
  },
})

const BACK_OVERLAY = genElementValueField({
  as: FieldColorPicker<string | null>,
  name: 'back.overlay',
  label: t('input.label.overlay'),
  defaultValue: null,
  useConfigs: [useBrandColorOptions],
  props: { labeled: true, resettable: true },
})

const CardForm: CardFormValueType = ({ name, state, setState }) => {
  const handleAClick = () => setState({ isBack: false, pauseAnimation: false })
  const handleBClick = () => setState({ isBack: true, pauseAnimation: false })

  return (
    <>
      <Button
        className={cn({ [s.active]: !state?.isBack })}
        name='front'
        onClick={handleAClick}
        styleType='free'
        fluid
      >
        <Padding bottom fluid gap sides>
          <FormField config={chainName(name, FRONT_IMAGE)} />
          <FormField config={chainName(name, FRONT_OVERLAY)} />
        </Padding>
      </Button>
      <Divider free />
      <Button
        className={cn({ [s.active]: state?.isBack })}
        name='back'
        onClick={handleBClick}
        styleType='free'
        fluid
      >
        <Padding bottom fluid gap sides top>
          <FormField config={chainName(name, BACK_IMAGE)} />
          <FormField config={chainName(name, BACK_OVERLAY)} />
        </Padding>
      </Button>
    </>
  )
}

export default CardForm
